module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/fa98f5b1ca0cc2943e19ecd1d2d2cbb0.svg";